var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    [
      _c(
        "v-form",
        {
          ref: "form",
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            "v-list-item",
            [
              _c(
                "v-radio-group",
                {
                  staticClass: "mt-0",
                  attrs: { mandatory: "" },
                  model: {
                    value: _vm.showChildForm,
                    callback: function ($$v) {
                      _vm.showChildForm = $$v
                    },
                    expression: "showChildForm",
                  },
                },
                [
                  _c("v-radio", { attrs: { label: "Me", value: false } }),
                  _vm._v(" "),
                  _c("v-radio", { attrs: { label: "My Child", value: true } }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.showChildForm
            ? _c("v-list-item", { staticClass: "soli-grey" }, [
                _vm._v("Your Information:"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-list-item",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        staticClass: "py-05",
                        attrs: {
                          "prepend-inner-icon": "person",
                          label: "First Name",
                          outlined: "",
                          rules: [(v) => !!v || "First name is required"],
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.form.first_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "first_name", $$v)
                          },
                          expression: "form.first_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        staticClass: "py-05",
                        attrs: {
                          "prepend-inner-icon": _vm.$vuetify.breakpoint.xs
                            ? "person"
                            : null,
                          label: "Last Name",
                          outlined: "",
                          rules: [(v) => !!v || "Last name is required"],
                          dense: "",
                        },
                        model: {
                          value: _vm.form.last_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "last_name", $$v)
                          },
                          expression: "form.last_name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item",
            [
              _c("BookingEmail", {
                attrs: { errors: _vm.errors.email },
                model: {
                  value: _vm.form.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "email", $$v)
                  },
                  expression: "form.email",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item",
            [
              _c("SoliPhone", {
                attrs: { errors: _vm.errors.phone },
                on: {
                  input: function ($event) {
                    return _vm.$emit("input", $event)
                  },
                  blur: function ($event) {
                    return _vm.blurInput()
                  },
                },
                model: {
                  value: _vm.form.phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "phone", $$v)
                  },
                  expression: "form.phone",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "childForm",
          class: [_vm.showChildForm ? "appear" : "disappear"],
          model: {
            value: _vm.childFormValid,
            callback: function ($$v) {
              _vm.childFormValid = $$v
            },
            expression: "childFormValid",
          },
        },
        [
          _c("v-list-item", { staticClass: "soli-grey" }, [
            _vm._v(" Child Information: "),
          ]),
          _vm._v(" "),
          _c(
            "v-list-item",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        staticClass: "py-05",
                        attrs: {
                          "prepend-inner-icon": "person",
                          label: "First Name",
                          outlined: "",
                          "hide-details": "",
                          rules: _vm.showChildForm
                            ? [(v) => !!v || "First name is required"]
                            : [],
                          dense: "",
                        },
                        model: {
                          value: _vm.childForm.child_first_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.childForm, "child_first_name", $$v)
                          },
                          expression: "childForm.child_first_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        staticClass: "py-05",
                        attrs: {
                          label: "Last Name",
                          outlined: "",
                          rules: _vm.showChildForm
                            ? [(v) => !!v || "Last name is required"]
                            : [],
                          "prepend-inner-icon": _vm.$vuetify.breakpoint.xs
                            ? "person"
                            : null,
                          dense: "",
                        },
                        model: {
                          value: _vm.childForm.child_last_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.childForm, "child_last_name", $$v)
                          },
                          expression: "childForm.child_last_name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item",
            [
              _c("SoliBirthday", {
                key: _vm.showChildForm,
                attrs: {
                  label: "Child's Birthday",
                  required: _vm.showChildForm,
                },
                model: {
                  value: _vm.childForm.birthday,
                  callback: function ($$v) {
                    _vm.$set(_vm.childForm, "birthday", $$v)
                  },
                  expression: "childForm.birthday",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }